let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jsJXH")).then(() => parcelRequire('bRp3T'));